export const init = () => {
    if (document.querySelector('.s-model-page')) {
        const mediaQuery = window.matchMedia('(max-width: 1055px)');

        const title = document.getElementById("js-models-page-title");
        const preHeader = document.getElementById("js-models-page-pre-header");
        const infoBox = document.getElementById("js-models-page-info-box");

        // console.log(document.querySelector(".b-media-container"));


        function handleWindowSizeChange(event) {
            if (event.matches) {
                // Moving
                document.querySelector(".b-media-container").insertAdjacentElement('beforebegin', title);
                document.querySelector(".b-media-container").insertAdjacentElement('beforebegin', preHeader);
                document.querySelector(".b-media-container").insertAdjacentElement('afterend', infoBox);
            } else {
                document.getElementById("js-models-page-right-content").insertAdjacentElement('beforeend', preHeader);
                document.getElementById("js-models-page-right-content").insertAdjacentElement('beforeend', title);
                document.getElementById("js-models-page-right-content").insertAdjacentElement('beforeend', infoBox);
            }
        }

        handleWindowSizeChange(mediaQuery);

        mediaQuery.addListener(handleWindowSizeChange);
    }
};